import React from "react";
import { AsyncPaginate, type LoadOptions } from "react-select-async-paginate";

export interface CommonOption {
  label: string;
  value: string;
  [key: string]: any;
}

interface AsyncPaginateMultiSelectProps {
  name: string;
  value: CommonOption[]; // 👈 array for multi select
  loadOptions: LoadOptions<CommonOption, any, any>;
  onChange: (options: CommonOption[]) => void;
  placeholder?: string;
  debounceTimeout?: number;
  className?: string;
  additional?: any;
  isClearable?: boolean;
}

export const AsyncPaginateMultiSelect: React.FC<
  AsyncPaginateMultiSelectProps
> = ({
  name,
  value,
  loadOptions,
  onChange,
  placeholder = "Select cities...",
  debounceTimeout = 300,
  className = "w-full",
  additional = { page: 1 },
  isClearable = true,
}) => {
  return (
    <AsyncPaginate
      name={name}
      value={value}
      loadOptions={loadOptions}
      onChange={(selected) => onChange(selected ? [...selected] : [])}
      additional={additional}
      debounceTimeout={debounceTimeout}
      placeholder={placeholder}
      className={className}
      isMulti // 👈 ENABLE MULTIPLE SELECT
      isClearable={isClearable}
      closeMenuOnSelect={false} // 👈 keeps dropdown open
    />
  );
};
